import { SvgIcon, SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

export const Invoice = forwardRef((props: SvgIconProps, ref: React.Ref<SVGSVGElement>) => {
  const { ...rest } = props;
  return (
    <SvgIcon {...rest} ref={ref}>
      <path d="M9,7H15V9H11V11H14V13H11V17H9V7M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5Z" />
    </SvgIcon>
  );
});

Invoice.displayName = "Invoice";
